import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthProvider } from 'src/app/services/shared/autorizacion';

@Injectable({
  providedIn: 'root'
})
export class ModuloGuard implements CanActivate {

  constructor(
    private usuario: AuthProvider,
    private navCtrl: NavController,
  ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (!!this.usuario && !!this.usuario.passCard && !!this.usuario.passCard.LstModulos) {

      const lstUrl = state.url.split('/');
      if (lstUrl.length > 1) {
        const itmModule = this.usuario.passCard.LstModulos.find(f => f.component.indexOf(lstUrl[1]) > -1)
        if (!!itmModule) {
          return true;
        } else {
          this.navCtrl.navigateRoot(this.usuario.passCard.LstModulos[0].component, { animated: true });
          return false;
        }
      } else {
        this.navCtrl.navigateRoot(this.usuario.passCard.LstModulos[0].component, { animated: true });
        return false;
      }


    } else {
      return false;
    }


  }

}
